import { Box, Typography } from '@mui/material';
import { MdOutlineStar } from 'react-icons/md';
import React, { useEffect, useState } from 'react';

const RatingBar = ({ rate, value }) => {
  const [values, setValues] = useState(0);

  useEffect(() => {
    setValues(0);

    setTimeout(() => {
      setValues(value);
    }, [100]);
  }, [value]);
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          columnGap: 0.5,
          mb: { xs: -0.7, sm: -0.5, md: 0, lg: 0 },
        }}
      >
        <Typography
          sx={{ fontSize: { lg: '12px', md: '12px', sm: '10px', xs: '10px' } }}
        >
          {rate}
        </Typography>
        <MdOutlineStar style={{ color: '#DF8E14' }} />
        <Box
          sx={{
            bgcolor: '#fff',
            border: '0.2px solid #d4d4d4',
            height: { lg: '10px', md: '10px', sm: '10px', xs: '8px' },
            width: '100%',
            borderRadius: '50px',
          }}
        >
          <Box
            sx={{
              height: '100%',
              transition: '0.4s all linear',
              width: `${values}%`,
              display: 'grid',
              placeItems: 'center',
              bgcolor: '#BC172F',
              borderRadius: '50px',
            }}
          >
            <Typography
              sx={{
                color: '#fff',
                fontSize: '8px',
                lineHeight: '0px',
                fontWeight: 500,
              }}
            >
              {/* {values}% */}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default RatingBar;
